import { useTranslation } from "react-i18next";
import { Form, Layout, Space, TableColumnsType, message } from "antd";
import PageHeader from "../../../../../../components/page-header/PageHeader";
import { useEffect, useMemo, useState } from "react";
import { routesConfig } from "../../../../../../config/routes";
import { useLocation, useParams } from "react-router-dom";
import TableData from "../../../../../../components/table-data/TableData";
import { TableProps } from "antd/lib";
import { DataTypeMoocActionHistory, FilterDataMoocActionHistory } from "../../../../../../types/course-plan-managment/mooc-action-history";
import { getMoocCourseConstructionPlanHistory } from "../../../../../../service/course-plan-managment/planning-course-construction/PlanningCourseConstructionApi";
import { formatDateToIsoStringHHss } from "../../../../../../utils/converDate";
import { isEmpty } from "lodash";
import moment from "moment";

const ApproveCouresConsrtuctionHistory = () => {
  const { t } = useTranslation();
    const imgPath = "/images/";
    const [form] = Form.useForm();
    const [loading, setLoading] = useState<boolean>(false);
    const [searchValue, setSearchValue] = useState<string>('');
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(10);
    const [listMoocActionHistory, setListMoocActionHistory] = useState();
    const [statusOrder, setStatusOrder] = useState<string>("");
    const [fieldSortOrder, setFieldSortOrder] = useState<string>("");
    const [filterData, setFilterData] = useState<FilterDataMoocActionHistory>({});
    const { id } = useParams();
    const location = useLocation();
    const state = location.state;

    const listBreadcrumb = [
        {
          title: (
            <a
              href={`/${routesConfig.coursePlan}/${routesConfig.registerCoursePlan}/${routesConfig.moocCourseConstructionPlan}`}
            >
              {t("Kế hoạch khóa học", "Kế hoạch khóa học")}
            </a>
          ),
        },
        {
          title: (
            <a
              href={`/${routesConfig.coursePlan}/${routesConfig.registerCoursePlan}/${routesConfig.moocCourseConstructionPlan}/${routesConfig.moocCourseConstructionPlanDetail}/${id}`}
            >
              {t("Xây dựng nội dung khóa học", "Xây dựng nội dung khóa học")}
            </a>
          ),
        },
        {
          title: `${state.registrationName}`,
        },
      ];

    const dataColumns: TableColumnsType<any> = [
    {
        title: t("STT", "STT"),
        key: "numericalOrder",
        width: 1,
        render: (_: any, record, index: number) => {
          const orderNumber = (index + 1).toString().padStart(2);
          return <span className="table-order-header">{orderNumber}</span>;
        },
    },
    {
        title: t("Người thao tác", "Người thao tác"), //dropdown
        dataIndex: "userId",
        key: "userId",
        width: 2,
        render: (_: any, record, index: number) => {
          const userName = `${record.authUser.authUserprofile.name ? record.authUser.authUserprofile.name : record.authUser.username}`

          return <span className="table-order-header">{userName}</span>;
        },
    },
    {
        title: t("Thời gian", "Thời gian"), //clendar
        dataIndex: "loggedTime",
        key: "loggedTime",
        width: 2,
        render: (_: any, record, index: number) => {
          const dateTimeConvert = record?.loggedTime
            // ? formatDateToIsoStringHHss(record?.loggedTime.toString())
            ? !isEmpty(record?.loggedTime) ? moment(record?.loggedTime).format('HH:mm:ss DD/MM/YYYY') : null
            : null;
          
          
          return (
            <Space direction="vertical">
              <span>{dateTimeConvert}</span>
            </Space>
          );
        },
    },
    {
        title: t("Thao tác", "Thao tác"), //text
        dataIndex: "actionDetail",
        key: "actionDetail",
        width: 3,
    },
    ];

    const getListData = (id:number) => {
      setLoading(true);
  
      const data = {
        keyword: searchValue,
        pageNumber: pageNumber,
        pageSize: pageSize,
        sortField: fieldSortOrder,
        sortOrder: statusOrder,
        courseConstructionPlanId: Number(id),
      };
  
      getMoocCourseConstructionPlanHistory(data)
        .then((res) => {
          const { data } = res.data;
          console.log(data.data);
          
          setListMoocActionHistory(data.data);
          setTotalRecords(data.totalRecords);
          setTimeout(() => {
            setLoading(false);
          }, 500);
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
          message.error(t("Có lỗi chưa xác định", "Có lỗi chưa xác định"));
        });
    };

    useEffect(()=> {
      getListData(Number(id));
    },[id])

    const defaultCheckedList = dataColumns.map((item) => item.key as string);
    const [checkedList, setCheckedList] = useState(defaultCheckedList);
    const newColumns = useMemo(() => {
        return dataColumns.map((item, index: number) => ({
        ...item,
        hidden: !checkedList.includes(item.key as string),
        }));
    }, [checkedList]);

    const handleTableChange: TableProps["onChange"] = (
        pagination,
        filters,
        sorter: any
      ) => {
        const data =
          sorter.order === "ascend"
            ? "asc"
            : sorter.order === "descend"
            ? "desc"
            : "";
        setStatusOrder(data);
        setFieldSortOrder(sorter.field);
      };

    return (
        <Layout className="page-header-group course-construction">
        <Form.Provider
            onFormFinish={(formName, { values, forms }) => {
            if (formName === "create-edit-mooc-action-history-detail") {
                console.log("valuesForm", values);
            }
            }}
        >
            <div
            className={`page-header-group--layout`}
            >
            <div className="table-header--wrapper">
                <div className="table-header--left">
                <PageHeader
                    title={`${t("Lịch sử thao tác khóa học", "Lịch sử thao tác khóa học")} ${state.registrationName}`}
                    listBreadcrumb={listBreadcrumb}
                    arrowLeft={imgPath + "arrowLeft.svg"}
                    positionItem="column"
                    breadcrumb={true}
                />
                </div>
            </div>
            </div>

            <div className="tabs-heading">
            <TableData
                dataTable={listMoocActionHistory}
                dataColumns={newColumns}
                setPageNumber={setPageNumber}
                setPageSize={setPageSize}
                pageNumber={pageNumber}
                pageSize={pageSize}
                loadingTable={loading}
                // scroll={{ x: 1500, y: 600 }}
                totalRecords={totalRecords}
                handleTableChangeProps={handleTableChange}
                pagination={true}
            />
            </div>
        </Form.Provider>
        </Layout>
    )
}

export default ApproveCouresConsrtuctionHistory;